function googleTranslateElementInit() {
  new google.translate.TranslateElement(
    {
      includedLanguages: 'ar,bn,zh-CN,zh-TW,en,fr,de,gu,ht,it,km,ko,ne,pl,pt,ru,es,vi',
      layout: google.translate.TranslateElement.InlineLayout.VERTICAL,
      autoDisplay: false
    },
    'google_translate_element'
  );
}